<template>
  <div class="tab-content">
    <users-list users-type="inactive" />
  </div>
</template>

<script>
import UsersList from "./UsersList.vue";

export default {
  components: {
    UsersList,
  },
};
</script>
